import URLS from '../config/urls';
import BaseAPI from './BaseApi';


class DashboardService {
    async getList(): Promise<any> {
        try {
            const response = await BaseAPI.put(`${URLS.DASHBOARD}`);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }
}

const dashboardService = new DashboardService();
export default dashboardService;